export default __webpack_public_path__ + "static/media/generic-icon.60c53dbc.png";